import { render, staticRenderFns } from "./SwipeScreen2.vue?vue&type=template&id=bcfba806"
import script from "./SwipeScreen2.vue?vue&type=script&lang=js"
export * from "./SwipeScreen2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports